import { useEffect, useReducer } from 'react'
import { getLanguage, setLanguage, subscribe, t } from './i18n'
import type { Language } from './messages'

export interface UseTranslation {
  /** `<namespace>.<dot.path>` 形式の key で翻訳する。`#{var}` で変数置換可。 */
  t: (key: string, vars?: Record<string, string | number>) => string
  language: Language
  setLanguage: (next: Language) => void
}

/**
 * `useTranslation()` — Component から t() を呼ぶための薄いフック。
 * `setLanguage` が呼ばれると subscribe 経由で再描画する。
 *
 * 軽量自作の理由: react-i18next 等は複数化 / Trans / namespace lazy load 等の
 * 機能を含むが、現時点 (Phase 3) では単純なキー参照と `#{var}` 補間だけで十分なため。
 * 将来 Trans / 複数化が必要になったら互換 API を保ったまま react-i18next に置き換える。
 */
export const useTranslation = (): UseTranslation => {
  const [, forceRender] = useReducer((x: number) => x + 1, 0)

  useEffect(() => subscribe(forceRender), [])

  return {
    t,
    language: getLanguage(),
    setLanguage,
  }
}
